module.exports = __webpack_public_path__ + "static/media/herramientas-ico.6dd5b2ec.svg";